module.exports = __webpack_public_path__ + "img/Find_resumes_blue.4b5da496.svg";